module.exports = __webpack_public_path__ + "img/cooperationAdvantagesImg4.43a85d42.png";